var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1352 1544",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1352v1544h-1352z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,76)",
    d: "m0 0h56l1 55 55 1 1 4-1 52h56l1 55h53l1-54 1-1h56l-1-6v-49l1-1h56v56h56v56h-56v56l-55 1v54l111 1v56l-55 1v54l111 1v112h-56l-1-13v-43h-111l1 167 111 1v56l-55 1-1 55h56v56l3-1 52 1v-55l1-1h56v336l-55 1-1 55h-112l1 5-1 107h56v112h-56l-1-13v-43h-167l-1-9v-47h-55l-1-5v-51h-55l-1-6v-271l1-3-55 1-1 55h-56l-1-6v-50h-55l-1-6v-50h-55l-1-4v-108h-167l-1-6v-49l1-1 111-1v-52l1-3 9-1 103 1-1-6v-50h-55l-1-4v-51l1-1 55-1v-55h-55l-1-6v-50l-110 1v54l55 1v56h-112l-1-5v-162l1-1h392l-1-6v-49l1-1h56l-1-5v-162l-111-1-1-6v-103z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400)",
    d: "m0 0h952v804l-56 1-1 55h-55v-56h-56v-55l1-1h55v-56h-111l-1-1v-167h111l1 56h56v-112h-111l-1-1v-54l1-1h55v-56h-111l-1-1v-54l1-1h55v-56h56v-56h-56v-56l-56 1v55l-56 1-1 54-1 1h-53l-1-1v-55h-56v-56h-55l-1-1v-55h-56v112h111l1 3v165l-56 1v55l-392 1v167h112v-56h-55l-1-1v-54l1-1h110l1 56h55l1 55-1 1-55 1v55h55l1 56h-112v55l-1 1-111 1v55h167l1 112h-56v-56h-168v-224h-56v-56l-112 1v55h-56v-56h-56v-56h112v-56h55l1 3v53h56v-56h56v-56h-56v-55l1-1h55v-56h-112v-56h-55l-1-1v-111h56v-56h111l1 3v109h56v-112h-56v-56h-55l-1-1z",
    fill: "#1E1B1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h400l1 19 55 1v56h56v112h-56l-1-6v-105l-111-1v56h-56l1 111 55 1v56l8-1 104 1v56l-55 1-1 55h56v56h-56v56h-56l-1-5v-50l-55-1v56h-112l1 5-1 51h56v56h56l-1-5v-50l1-1h112v56h56v224h-56l-1-10v-46l-54 1-1 55-55 1v110l55 1 1 55 111 1v56l-111 1-1 55h-56l-1-11v-45h-55l-1-5v-107h-167l-1-5v-49l1-2h-56v-56h-8z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,860)",
    d: "m0 0h8v56h56v56h167l1 112h55l1 56h56v-55l1-1h111v-56h55l1 3v109h-112l-1 56-167 1v55h167v56l-111 1v55h167l1 56h55l1 56h56v-56h56v-56h-56v-56h111l1 3v109l55-1 1-111h55l1 236h-792z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h400l1 19 55 1v56h56v112h-56l-1-6v-105l-111-1v56h-56l1 111 55 1v56l8-1 104 1v56l-55 1-1 55h56v56h-56v56h-56l-1-5v-50l-167-1v-56h-111l-1-1v-110l1-1h55v-56h-111l-1-1v-54l-1-56-7-1z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,20)",
    d: "m0 0h223v784l-56 1-1 55h-55v-56h-56v-55l1-1h55v-56h-111l-1-1v-167h111l1 56h56v-112h-111l-1-1v-54l1-1h55v-56h-111l-1-1v-54l1-1h55v-56h56v-56h-56v-56l-56 1v55l-56 1-1 54-1 1h-53l-1-1v-55h-56v-56h112v-55l1-1h55v-55z",
    fill: "#1E1B1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,76)",
    d: "m0 0h56l1 55 55 1 1 4-1 52h56l1 55h53l1-54 1-1h56l-1-6v-49l1-1h56v56h56v56h-56v56l-55 1v54l111 1v56l-55 1v54l111 1v112h-56l-1-13v-43h-111l-1-6v-106h-55l-1-5v-107h-55v56h-56l-1-5v-162l-111-1-1-6v-103z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,356)",
    d: "m0 0h56v56h56v56h-56v55l-1 1h-55l-1-5v-50h-54l-1 55-55 1-1 167h-56l-1-6v-50h-55l-1-4v-51l1-1 55-1v-55h-55l-1-6v-50l-110 1v54l55 1v56h-112l-1-5v-162l1-1h392l-1-6v-49z",
    fill: "#FEFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,468)",
    d: "m0 0h110l1 56h55l1 55-1 1-55 1v55h55l1 56h-112v55l-1 1-111 1v55h167l1 112h-56v-56h-168v-224h56v-56h112v-56h-55l-1-1v-54z",
    fill: "#1E1B1C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,691)",
    d: "m0 0 108 1 1 55 167 1v56l-111 1v54l111 1v112l-55 1-1 55h-56l-1-6v-50h-55l-1-6v-50h-55l-1-4v-108h-167l-1-6v-49l1-1 111-1v-52l1-3z",
    fill: "#FEFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1297,1140)",
    d: "m0 0h55v404h-224v-67l1-1h55v-56h56v-112h-56v-112h112v-55z",
    fill: "#1E1B1C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,300)",
    d: "m0 0h55l1 112h55l1 112-112 1v55h-168v112h55l1 56h-167l-1-1v-55h56v-167l1-1h55v-55l1-1h54l1 3v53l55-1 1-55h56v-56h-56v-56h56z",
    fill: "#1E1B1C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,1140)",
    d: "m0 0h112v112l-55 1v54l111 1v56h56v56h-56v56h-56l-1-6v-50h-55l-1-9v-47h-167l-1-5v-50l1-1h111v-56h-167l-1-6v-49l1-1h167v-54z",
    fill: "#FEFEFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,1308)",
    d: "m0 0h111l1 3v109l55-1 1-111h55l1 236h-280v-68h56v-56h56v-56h-56z",
    fill: "#1E1B1C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,972)",
    d: "m0 0h55l1 3v53h56v-56h55l1 56h56v-55l1-1h55v280h-111l-1-1v-55h56v-56h-55l-1-1v-55h-223l-1-1v-55h56z",
    fill: "#1E1B1C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,20)",
    d: "m0 0h223v56h-112v112h-56v-56l-56 1v55l-56 1-1 54-1 1h-53l-1-1v-55h-56v-56h112v-55l1-1h55v-55z",
    fill: "#1E1B1C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,1028)",
    d: "m0 0h55l1 3v109h-112l-1 56-167 1v55h-111l-1-1v-54l1-1h55v-56h56v-56h55l1 56h56v-55l1-1h111z",
    fill: "#1E1B1C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,636)",
    d: "m0 0h56v56h112v55l-1 1-111 1v55h167l1 112h-56v-56h-168z",
    fill: "#1E1B1C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568)",
    d: "m0 0h168v20h56v55l-1 1h-55l-1-10v-45h-110l-1 55h56v168l-55 1-1 55h-56l-1-5v-106l1-1 55-1v-55h-55l-1-4v-124z",
    fill: "#FEFEFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400)",
    d: "m0 0h168v132h55l1 55-1 1-55 1v111h-56v-56h-56v-56h56v-112h-56v-56h-55l-1-1z",
    fill: "#1E1B1C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(344,76)",
    d: "m0 0h111l1 3v109l-56 1v55h55l1 56h-112v-56h-55l-1-1v-111h56z",
    fill: "#1E1B1C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,748)",
    d: "m0 0h55l1 3v52l55 1v56h-56l1 56h111l1 56h-168v-112h-111l-1-1v-54l1-1h111z",
    fill: "#1E1B1C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,804)",
    d: "m0 0h54l1 56h56v168h-111l-1-1v-55h-55l-1-1v-110l1-1h55v-55z",
    fill: "#1E1B1C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176)",
    d: "m0 0h224l1 19 55 1v56h56v112h-56l-1-6v-105l-111-1v56h-56l-1-9v-46l-55-1-1-8v-48h-55z",
    fill: "#FEFEFE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(8,1196)",
    d: "m0 0h55l1 111-1 1-54 1-1 111h55l1 3v109h112v-55l1-1h110l1 38v18h168v12h-456v-292h8z",
    fill: "#1E1B1C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,1364)",
    d: "m0 0h167l1 56-112 1-1 54-1 1h-110v55l-3 1h-109v-56h56v-55l1-1h111z",
    fill: "#1E1B1C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(961,1028)",
    d: "m0 0h110l1 2v53l-1 1h-55v56h112v-55l1-1h54l1 3v109h-224v-167z",
    fill: "#1E1B1C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(120,244)",
    d: "m0 0h55l1 3v53h167l1 3v52l-1 1h-168l1 56h-111l-1-1v-110l1-1h55z",
    fill: "#1E1B1C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,692)",
    d: "m0 0h54l1 3v53h55v112l-55 1-1 54-1 1h-110v-56h56v-56h-56v-56h56v-55z",
    fill: "#1E1B1C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1129,804)",
    d: "m0 0h54l1 3v53h56v56h55l1 56-56 1-1 111h-54l-1-1v-167h-112v-55l1-1h55v-55z",
    fill: "#1E1B1C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904)",
    d: "m0 0h448v20l-223 1-1 55-55 1-1 55h-112l-1-5v-106l-55-1z",
    fill: "#FEFEFE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,860)",
    d: "m0 0h8v56h56v56h167l1 112h-56v-56l-112 1-1 54-2 1h-61z",
    fill: "#1E1B1C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1240,76)",
    d: "m0 0h112v280h-56l-1-6v-162h-55l-1-5v-105z",
    fill: "#FEFEFE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(736,188)",
    d: "m0 0h112l1 55 55 1v56h-56v55l-1 1h-55l-1-5v-107h-55l-1-6v-46z",
    fill: "#FEFEFE"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,524)",
    d: "m0 0h111l1 56h-56v56h55l1 56h-111l-1-1z",
    fill: "#1E1B1C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1296,804)",
    d: "m0 0h56v168h-56l-1-11v-45h-55l-1-4v-49l1-3 3-1 52 1v-55z",
    fill: "#FEFEFE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,1252)",
    d: "m0 0h55l1 56h55l1 56h-167l-1-1v-54l1-1h55z",
    fill: "#1E1B1C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,1252)",
    d: "m0 0h167v56l-111 1v55h-56z",
    fill: "#1E1B1C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,1140)",
    d: "m0 0h55l1 168h-111l-1-1v-54l1-1h55z",
    fill: "#1E1B1C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,188)",
    d: "m0 0h56v56h56v56h56v56h-56l-1-4v-51l-55-1-1-13v-43h-55l-1-6v-49z",
    fill: "#FEFEFE"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,356)",
    d: "m0 0h56v56h56v56h-112l-1-62v-49z",
    fill: "#FEFEFE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(288,1364)",
    d: "m0 0h167l1 56h-167l-1-1z",
    fill: "#1E1B1C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,1140)",
    d: "m0 0h110l1 55-1 1-55 1v55h-55l-1-1v-110z",
    fill: "#1E1B1C"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(288,636)",
    d: "m0 0h111l1 3-1 109h-54l-1-1v-55h-55l-1-1z",
    fill: "#1E1B1C"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(177,1476)",
    d: "m0 0h110l1 38v18h168v12h-224v-12h-56v-55z",
    fill: "#1E1B1C"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(8,1196)",
    d: "m0 0h55l1 111-1 1-54 1v130l-1 37h-8v-224h8z",
    fill: "#1E1B1C"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1296,1420)",
    d: "m0 0h56v124h-56l-1-14v-108z",
    fill: "#FEFEFE"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1296,1252)",
    d: "m0 0h56v112h-56l-1-5v-104z",
    fill: "#FEFEFE"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,132)",
    d: "m0 0h56v56h56v56h-56l-1-9v-46l-55-1-1-6v-49z",
    fill: "#FEFEFE"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,580)",
    d: "m0 0h56v56h56v56h-56l-1-9v-47h-55l-1-10v-44z",
    fill: "#FEFEFE"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,636)",
    d: "m0 0h112v56h-112l-1-4v-49z",
    fill: "#FEFEFE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,412)",
    d: "m0 0h111l1 56h-112z",
    fill: "#1E1B1C"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(8,188)",
    d: "m0 0h111l1 2v54h-111l-1-1z",
    fill: "#1E1B1C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,76)",
    d: "m0 0h54l1 3v109h-55l-1-1v-110z",
    fill: "#1E1B1C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,468)",
    d: "m0 0h7l1 1v55h55l1 2v53l-1 1h-55v55l-1 1h-7z",
    fill: "#1E1B1C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h176v20h-168v55l-1 1h-7z",
    fill: "#1E1B1C"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,1476)",
    d: "m0 0h56v68h-56l-1-17v-50z",
    fill: "#FEFEFE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,580)",
    d: "m0 0h56l1 3-1 53h-56l-1-6v-49z",
    fill: "#FEFEFE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,300)",
    d: "m0 0h56v56h-56l-1-6v-47z",
    fill: "#FEFEFE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,1476)",
    d: "m0 0h56v55l-2 1h-54l-1-14v-39z",
    fill: "#FEFEFE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(11,859)",
    d: "m0 0 53 1v56h-56v-56z",
    fill: "#FEFEFE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1296,972)",
    d: "m0 0h56v56h-55l-1-1z",
    fill: "#1E1B1C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1128,188)",
    d: "m0 0h55l1 3v53h-55l-1-1z",
    fill: "#1E1B1C"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,412)",
    d: "m0 0h55l1 2v54h-56z",
    fill: "#1E1B1C"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(456,1420)",
    d: "m0 0h55l1 56h-55l-1-1z",
    fill: "#1E1B1C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,1252)",
    d: "m0 0h55l1 56h-56z",
    fill: "#1E1B1C"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(569,916)",
    d: "m0 0h54l1 3v53h-56v-55z",
    fill: "#1E1B1C"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,1084)",
    d: "m0 0h54l1 2v54h-55l-1-1v-48z",
    fill: "#1E1B1C"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(680,916)",
    d: "m0 0h55l1 56h-56z",
    fill: "#1E1B1C"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(289,20)",
    d: "m0 0h54l1 56h-56v-55z",
    fill: "#1E1B1C"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(232,76)",
    d: "m0 0h55l1 2v54h-55l-1-1z",
    fill: "#1E1B1C"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,580)",
    d: "m0 0h55l1 55-1 1h-54l-1-1z",
    fill: "#1E1B1C"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,468)",
    d: "m0 0h54l1 56h-55l-1-1v-54z",
    fill: "#1E1B1C"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,412)",
    d: "m0 0h54l1 56h-56v-55z",
    fill: "#1E1B1C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,1364)",
    d: "m0 0h55l1 3v52l-1 1h-54l-1-1z",
    fill: "#1E1B1C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,20)",
    d: "m0 0h55l1 56h-56z",
    fill: "#1E1B1C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,1308)",
    d: "m0 0h54l1 56h-56v-55z",
    fill: "#1E1B1C"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(9,804)",
    d: "m0 0h54l1 56h-56v-55z",
    fill: "#1E1B1C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(121,580)",
    d: "m0 0h54l1 56h-55l-1-1v-54z",
    fill: "#1E1B1C"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(65,1364)",
    d: "m0 0h54l1 3v52l-1 1h-55v-55z",
    fill: "#1E1B1C"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(513,972)",
    d: "m0 0h54l1 56h-56v-55z",
    fill: "#1E1B1C"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,636)",
    d: "m0 0h55l1 3-1 53h-54l-1-1z",
    fill: "#1E1B1C"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(961,692)",
    d: "m0 0h54l1 55-1 1h-55v-55z",
    fill: "#1E1B1C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1072,972)",
    d: "m0 0h55l1 55-1 1h-54l-1-1z",
    fill: "#1E1B1C"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,1252)",
    d: "m0 0h54v56h-55v-55z",
    fill: "#1E1B1C"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,188)",
    d: "m0 0h55v56h-54l-1-1z",
    fill: "#1E1B1C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(960)",
    d: "m0 0h112v18l-2 2h-110z",
    fill: "#1E1B1C"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1016,1532)",
    d: "m0 0h56v12h-56z",
    fill: "#1E1B1C"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(568,1532)",
    d: "m0 0h56v12h-56z",
    fill: "#FEFEFE"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(176,1532)",
    d: "m0 0h56v12h-56z",
    fill: "#FEFEFE"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(8,1532)",
    d: "m0 0h55l1 1v11h-56z",
    fill: "#FEFEFE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1420)",
    d: "m0 0h8l1 2v17l-1 37h-8z",
    fill: "#FEFEFE"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1196)",
    d: "m0 0h8l1 1v18l-1 37h-8z",
    fill: "#FEFEFE"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,972)",
    d: "m0 0h8v56h-8z",
    fill: "#FEFEFE"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,1140)",
    d: "m0 0h7l1 1v55h-8z",
    fill: "#1E1B1C"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,132)",
    d: "m0 0h7l1 1v55h-8z",
    fill: "#1E1B1C"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0,692)",
    d: "m0 0h7l1 1v54l-1 1h-7z",
    fill: "#1E1B1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.497fc1e58117d82455c5a63d11dbca1d.svg";
export { ForwardRef as ReactComponent };